<script setup lang="ts">
import { type IdTitle } from '@itinerary/ItineraryModuleTypes';

interface IProps {
    items?: IdTitle[];
    column?: boolean;
}
const { items = [], column } = defineProps<IProps>();
const modelValue = defineModel<string[]>({ default: [] });
const toggle = (index: number) => {
    const val = items[index].id;
    if (modelValue.value.includes(val)) {
        modelValue.value = modelValue.value.filter(
            selectedVal => selectedVal !== val
        );
    } else {
        modelValue.value = [...modelValue.value, val];
    }
};
const clear = () => {
    modelValue.value = [];
};
defineExpose({ clear });
</script>

<template>
    <div class="btn-group" :class="{ column }">
        <mr-checkbox
            v-for="(item, index) in items"
            :key="index"
            class="btn-container"
            :label="item.title"
            :style="!column && { width: `${100 / items.length}%` }"
            :model-value="modelValue?.includes(item.id)"
            @update:model-value="toggle(index)"
        />
    </div>
</template>

<style scoped lang="scss">
.btn-group {
    margin: 0;
    padding-bottom: 8px;
    display: flex;
    justify-content: space-between;
    &.column {
        flex-direction: column;
    }
    .btn-container {
        padding: 0 4px;
    }
}
</style>
